export const name = 'feature-flags';

// Constants
export { FEATURE_FLAGS } from './constants';

// Feature flag hook
export { useFeatureFlag } from './feature-flag';
export { appSlice as featureFlagAppSlice } from './feature-flag/store';

// Hooks
export {
  useFeatureFlagImpersonatorOverride,
  FF_IMPERSONATOR_OVERRIDE_PARAM,
  type FeatureFlagUserOverride,
} from './hooks';

// Types
export type {
  SettingValue,
  NullableSettingValue,
  OptionalSettingValue,
  FeatureFlagValue,
  SettingTypeOf,
} from './types';

// ConfigCat utilities
export { DEFAULT_CONFIGCAT_KEY, handleSDKKey } from './config-cat/handle-sdk-key';
export type {
  ConfigCatFeatureFlagUserConfig,
  ConfigCatUserProfile,
} from './config-cat/build-config-cat-user-profile';
export { buildConfigCatUserProfile } from './config-cat/build-config-cat-user-profile';
export { useConfigCatFeatureFlag } from './config-cat/useConfigCatFeatureFlag';
